export function distance(x0, y0, x1, y1) {
  return Math.sqrt((x0 - x1) ** 2 + (y0 - y1) ** 2)
}
